import { Box, Link, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import { RepairShopSearchResultDto } from '@src/model/repairShopDom'
import React from 'react'
import { useTranslation } from 'react-i18next'
const mapIcon = require('../assets/images/icons/googleMapsIcon.svg')

interface RepairShopItemProps {
  repairShop: RepairShopSearchResultDto
  headerComponent?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  id: string
}

const RepairShopItem = ({
  repairShop,
  headerComponent = 'h3',
  id,
}: RepairShopItemProps): JSX.Element => {
  const { name, address, partner, email, phone, hours } = repairShop
  const { t } = useTranslation('repairshop')
  const googleMaps = t('selection-page.google-maps')

  return (
    <Box
      component="section"
      sx={(theme) => ({
        flex: 1,
        p: 2,
        backgroundColor: theme.palette.common.white,
      })}
      id={id}
    >
      <Stack direction={'row'} gap={1}>
        <Typography
          variant="body1"
          component={headerComponent}
          gutterBottom
          sx={(theme) => ({
            color: theme.palette.primary.main,
            fontWeight: 700,
          })}
        >
          {`${partner.name} ${name}`}
        </Typography>
      </Stack>
      <Typography variant="body1" sx={{ display: 'inline-block' }}>
        {`${address.streetAddress} ${address.zipCode} ${address.city}`}
      </Typography>
      {phone && <Typography variant="body1">{`Puh. ${phone}`}</Typography>}
      <Typography variant="body1">{email}</Typography>
      <Typography variant="body1">{hours}</Typography>
      <Typography variant="body1" sx={{ fontWeight: '700' }}>
        {`${t('selection-page.distance')}: ${repairShop.distance.toFixed(
          1,
        )} km`}
      </Typography>
      <Link
        href={`https://www.google.com/maps/search/?api=1&query=${address.streetAddress} ${address.zipCode} ${address.city}`}
        target={'_blank'}
        sx={{
          '&.Mui-focusVisible': {
            outline: '5px solid #192d6a',
          },
        }}
      >
        <Stack
          direction="column"
          alignItems="center"
          sx={(theme) => ({
            mt: '-3rem',
            float: 'right',
            color: theme.palette.primary.main,
          })}
        >
          <img src={mapIcon} alt={''} />
          <Typography variant="body1">{googleMaps}</Typography>
        </Stack>
      </Link>
    </Box>
  )
}

export default RepairShopItem
